import { createEquipmentCategory, defaultAccessorials } from './internal.ts'

export const drayageEquipment = createEquipmentCategory(
  {
    bucket: 'drayage',
    mode: 'truckload',
    workflows: ['truckload'],
    accessorialTypes: defaultAccessorials,
  },
  [
    { key: 'drayage-20', name: "Drayage 20'" },
    { key: 'drayage-40', name: "Drayage 40'" },
    { key: 'drayage-45', name: "Drayage 45'" },
    { key: 'drayage-48', name: "Drayage 48'" },
    { key: 'drayage-53', name: "Drayage 53'" },
  ],
)
